import { createAction, props } from '@ngrx/store';
import { SubscriptionProduct } from '../../models';

export const loadProductsSuccess = createAction(
  '[Load Products Effects] Load Products Success',
  props<{ products: SubscriptionProduct[] }>()
);
export const loadProductsError = createAction(
  '[Load Products Effects] Load Products Error',
  props<{ error: unknown }>()
);
